import {
  UploadOutlined,
  WarningOutlined,
  ExclamationCircleFilled,
  EyeInvisibleOutlined,
  WarningFilled,
  PullRequestOutlined,
  PartitionOutlined,
} from '@ant-design/icons';
import {
  Alert,
  Button,
  Checkbox,
  DatePicker,
  Divider,
  Form,
  Input,
  Radio,
  Rate,
  Select,
  Space,
  TimePicker,
  Typography,
  Upload,
  InputNumber,
  Tooltip as AntdToolTip,
  Row,
  Col,
  Tag,
} from 'antd';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import classNames from 'classnames';
import React, { useState } from 'react';
import PlaceHolder from '../../../assets/icons/image-plus.svg';
import PlaceHolderVideo from '../../../assets/icons/video-plus.svg';
import FormulaIcon from '../../../assets/icons/function-1.svg';
import CalculationIcon from '../../../assets/icons/calculation.svg';
import { ReactComponent as ShuffleIcon } from '../../../assets/icons/shuffle.svg';
import { embedUrlGenerator } from '../../../utils/embed-url';
import { formLocale } from '../../../utils/formLocale';
import './style.less';
import { get } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { MERCHANTS_ICONS } from '../PropertiesPanel/FieldProperties';
import { useStagingAreaContext } from '../StagingAreaWithSections';

const HeaderInput = ({ item }) => {
  return (
    <div className="form-group-container">
      <div style={{ width: '85%' }}>
        <Typography.Title level={3} className="header-title">
          {item?.label}
        </Typography.Title>
        <label className="sub-label" dangerouslySetInnerHTML={{ __html: item?.description }} />
      </div>
      {/* <Divider /> */}
    </div>
  );
};

const EmailInput = ({ item }) => {
  return (
    <div className="form-group-container">
      <Form.Item label={item?.label} name={item?.id} tooltip={item?.hint} required={item?.required}>
        <Input size="large" disabled placeholder={item?.placeholderText} />
      </Form.Item>
      <label className="sub-label" dangerouslySetInnerHTML={{ __html: item?.description }} />
    </div>
  );
};

const PhoneInput = ({ item }) => {
  return (
    <div className="form-group-container">
      <Form.Item label={item?.label} name={item?.id} tooltip={item?.hint} required={item?.required}>
        {/* <Input size="large" disabled placeholder={item?.placeholderText} /> */}
        <ReactPhoneInput country={'us'} disabled={true} inputClass="ant input ant-input-lg" />
      </Form.Item>
      <label className="sub-label" dangerouslySetInnerHTML={{ __html: item?.description }} />
    </div>
  );
};

const TextInput = ({ item }) => {
  return (
    <div className="form-group-container">
      <Form.Item
        label={item?.label}
        name={item?.id}
        required={item?.required}
        tooltip={item?.hint}
        style={{
          flexWrap: 'nowrap',
        }}
      >
        {item.media && item.media.url && (
          <div className="image-container banner">
            <img src={item.media?.url} alt="" />
          </div>
        )}
        {item?.longAnswer ? (
          <Input.TextArea rows={2} disabled placeholder={item?.placeholderText} />
        ) : (
          <Input size="large" disabled placeholder={item?.placeholderText} />
        )}
      </Form.Item>
      <label className="sub-label" dangerouslySetInnerHTML={{ __html: item?.description }} />
    </div>
  );
};
const NumberInput = ({ item }) => {
  return (
    <div className="form-group-container">
      <Form.Item
        label={item?.label}
        name={item?.id}
        required={item?.required}
        tooltip={item?.hint}
        style={{ flexWrap: 'nowrap' }}
      >
        {item.media && item.media.url && (
          <div className="image-container banner">
            <img src={item.media?.url} alt="" />
          </div>
        )}
        <InputNumber
          disabled
          placeholder={item?.placeholderText}
          style={{ width: '100%' }}
          addonAfter={item?.suffix}
          addonBefore={item?.prefix}
        />
      </Form.Item>
      <label className="sub-label" dangerouslySetInnerHTML={{ __html: item?.description }} />
    </div>
  );
};
const FormulaField = ({ item, planHasAdvancedFields }) => {
  const { t } = useTranslation();
  const fieldErrors = useSelector((state) => state.errors.fields);

  const { invalidFormula, mutallyDependant } = fieldErrors[item?.questionId] ?? {};

  const hasSuffixOrPrefix = item?.suffix || item?.prefix;

  return (
    <div className="form-group-container">
      <Form.Item
        label={
          <>
            <span>{item?.label}</span>
            {!planHasAdvancedFields && (
              <AntdToolTip
                title={`${t('billing.formula')} ${t('billing.is-not-included-in-your-plan')}`}
                placement="right"
              >
                <ExclamationCircleFilled style={{ color: 'red', marginInlineStart: '0.5rem' }} />
              </AntdToolTip>
            )}
          </>
        }
        required={item?.required}
        tooltip={item?.hint}
        style={{ flexWrap: 'nowrap' }}
      >
        {!get(item, 'formula.expression') ? (
          <Alert type="warning" message={t('builder:errors.emptyForumla')} showIcon />
        ) : (
          <>
            <div
              className={classNames('formula-input-render', {
                'ant-input-wrapper ant-input-group ant-input-wrapper-readonly': hasSuffixOrPrefix,
                'ant-input-affix-wrapper ant-input-affix-wrapper-readonly': !hasSuffixOrPrefix,
              })}
            >
              {!hasSuffixOrPrefix && (
                <span className="ant-input-prefix">
                  <span style={{ width: 25, height: 26, display: 'flex' }}>
                    <img
                      src={CalculationIcon}
                      alt="drag icon"
                      style={{ width: 22, borderRadius: 3, padding: 2, marginLeft: -4 }}
                    />
                  </span>
                </span>
              )}
              {item?.prefix && <span className="ant-input-group-addon">{item?.prefix}</span>}
              <div className="ant-input">
                <div
                  className="formula-container"
                  dangerouslySetInnerHTML={{ __html: item?.formulaRender }}
                ></div>
              </div>
              {item?.suffix && <span className="ant-input-group-addon">{item?.suffix}</span>}
            </div>
          </>
        )}
      </Form.Item>
      {/* {!planHasAdvancedFields && (
        <div style={{ width: '96%' }}>
          <Alert type="error" message={t('builder:advancedFieldsDisabled')} showIcon />
        </div>
      )} */}
      {item?.hidden && (
        <div
          style={{
            display: 'flex',
            gap: 8,
            alignItems: 'center',
            fontSize: 12,
          }}
        >
          <EyeInvisibleOutlined style={{ marginInlineStart: '0.5rem' }} />
          <Typography.Text>Hidden in actual form</Typography.Text>
        </div>
      )}
      <label className="sub-label" dangerouslySetInnerHTML={{ __html: item?.description }} />
      {/* {mutallyDependant && (
        <div id="duplicate-error" style={{ width: '96%' }}>
          <Alert type="error" message={mutallyDependant} showIcon />
        </div>
      )} */}
      {
        invalidFormula && (
          <div id="duplicate-error" style={{ width: '96%' }}>
            <Alert type="error" message={invalidFormula} showIcon />
          </div>
        )
        // : (
        //   !get(item, 'formula.expression') && (
        //     <div id="duplicate-error" style={{ width: '96%' }}>
        //       <Alert type="warning" message={t('builder:errors.emptyForumla')} showIcon />
        //     </div>
        //   )
        // )
      }
    </div>
  );
};

const PaymentField = ({ item, planHasAdvancedFields }) => {
  const { t } = useTranslation();
  const noMerchant = !item?.merchants || item?.merchants?.length === 0;
  const isConfigured = (merchant) => {
    switch (merchant?.type) {
      case 'stripe':
        return !!merchant?.credentials?.accountId && merchant?.credentials?.detailsSubmitted;
      case 'paypal':
        return !!merchant?.credentials?.email;
      case 'razorpay':
        return !!merchant?.credentials?.keyId && !!merchant?.credentials?.keySecret;
      case 'cash':
        return merchant?.credentials?.label;
      default:
        return false;
    }
  };
  return (
    <div className="form-group-container">
      <Form.Item
        label={
          <>
            <span>{item?.label}</span>
            {!planHasAdvancedFields && (
              <AntdToolTip
                title={`${t('billing.payment')} ${t('billing.is-not-included-in-your-plan')}`}
                placement="right"
              >
                <ExclamationCircleFilled style={{ color: 'red', marginInlineStart: '0.5rem' }} />
              </AntdToolTip>
            )}
          </>
        }
        required={item?.required}
        tooltip={item?.hint}
        style={{ flexWrap: 'nowrap' }}
        className={classNames('payment-field', { 'no-merchant': noMerchant })}
      >
        <Radio.Group style={{ width: '100%' }}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '10px',
              gridAutoRows: '1fr',
            }}
          >
            {item?.merchants &&
              item?.merchants.map((merchant, index) => (
                <div
                  key={index}
                  className={classNames(`image-container choice-image`, {
                    selected: true,
                  })}
                  style={{ margin: 0, minHeight: 66 }}
                >
                  {merchant?.type === 'cash' ? (
                    <>
                      <img
                        src={MERCHANTS_ICONS[merchant?.type]}
                        alt=""
                        style={{
                          display: 'block',
                          width: '26px',
                          height: 'auto',
                          padding: 0,
                        }}
                      />
                      <Typography.Text strong style={{ fontSize: '0.85rem', marginLeft: '4px' }}>
                        {merchant?.credentials?.label}
                      </Typography.Text>
                    </>
                  ) : (
                    <img
                      src={MERCHANTS_ICONS[merchant?.type]}
                      style={{
                        display: 'block',
                        width: '66px',
                        height: 'auto',
                        padding: 0,
                      }}
                    />
                  )}

                  <Radio
                    value={merchant?.type}
                    style={{
                      visibility: 'hidden',
                      position: 'absolute',
                      pointerEvents: 'none',
                      top: '0',
                      display: 'none',
                    }}
                  >
                    {merchant?.type}
                  </Radio>
                  {!isConfigured(merchant) && (
                    <ExclamationCircleFilled
                      style={{
                        color: '#ff4d4f',
                        fontSize: '15px',
                        marginInline: merchant?.type !== 'stripe' && '0.5rem',
                      }}
                    />
                  )}
                </div>
              ))}
          </div>
        </Radio.Group>
      </Form.Item>

      {noMerchant && (
        <div style={{ width: '96%' }}>
          <Alert type="warning" message={t('builder:errors.noPaymentConfigured')} showIcon />
        </div>
      )}
    </div>
  );
};

const RatingInput = ({ item }) => {
  return (
    <div className="form-group-container">
      <Form.Item
        label={item?.label}
        name={item?.id}
        required={item?.required}
        tooltip={item?.hint}
        style={{ flexWrap: 'nowrap' }}
      >
        {item.media && item.media.url && (
          <div className="image-container banner">
            <img src={item.media?.url} alt="" />
          </div>
        )}
        {item.ratingStyle === 'star' && <Rate disabled className="star-rate" />}
        {item.ratingStyle === 'survey' && (
          <div className="survey-rate">
            {new Array(11).fill(0).map((el, index) => (
              <div key={index} className="survey-rate-item">
                {index}
              </div>
            ))}
          </div>
        )}
      </Form.Item>
      <label className="sub-label" dangerouslySetInnerHTML={{ __html: item?.description }} />
    </div>
  );
};

const SelectField = ({ item }) => {
  return (
    <div className="form-group-container">
      <Form.Item
        label={item?.label}
        name={item?.id}
        required={item?.required}
        tooltip={item?.hint}
        style={{
          flexWrap: 'nowrap',
        }}
      >
        {item.media && item.media.url && (
          <div className="image-container banner">
            <img src={item.media?.url} alt="" />
          </div>
        )}
        <Select size="large" disabled placeholder={item?.placeholderText} />
      </Form.Item>
      <label className="sub-label" dangerouslySetInnerHTML={{ __html: item?.description }} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginTop: 4,
          rowGap: 4,
          columnGap: 6,
          flexWrap: 'wrap',
        }}
      >
        {item &&
          item.options &&
          item.options.map((option, index, arr) => {
            if (index < 5)
              return (
                <label className="sub-label" style={{ width: 'fit-content' }} key={index}>
                  {option.label || `option ${index + 1}`}
                  {arr.length !== index + 1 && index < 4 && ','}
                </label>
              );
          })}
        {item.options?.length > 5 && (
          <label
            className="sub-label"
            style={{ background: '#e6e6e6', padding: '4px 6px', borderRadius: 5 }}
          >
            +{item.options.length - 5} more
          </label>
        )}
      </div>
    </div>
  );
};

const RadioField = ({ item, errors, t }) => {
  const [value, setValue] = useState(1);

  const { sectionMap, sectionOrder } = useStagingAreaContext();
  // const { t } = useTranslation(['builder']);
  const onChange = (e) => {
    setValue(e.target.value);
  };
  const hasUploads = (options) => {
    if (!options) return false;
    return options.some((option) => option.media && option.media.url);
  };

  const hasDuplicateValues = errors && errors.duplicateFields.find((id) => id === item?.questionId);

  return (
    <div className="form-group-container">
      <Form.Item
        label={item?.label}
        name={item?.id}
        required={item?.required}
        tooltip={item?.hint}
        style={{
          flexWrap: 'nowrap',
        }}
      >
        {item.media && item.media.url && (
          <div className="image-container banner">
            <img src={item.media?.url} alt={item.media?.name} />
          </div>
        )}
        <Radio.Group onChange={onChange} disabled style={{ width: '100%' }}>
          <Space
            direction="vertical"
            className={classNames({
              'grid-layout': hasUploads(item.options),
            })}
          >
            {item &&
              item.options &&
              item.options.map((option, index) => (
                <div key={index}>
                  {option.media && option.media.url && (
                    <div className="image-container options-image">
                      <img src={option.media.url} alt={option.media?.name} />
                    </div>
                  )}
                  {!option.media && hasUploads(item.options) && (
                    <div className="image-container-placeholder options-image" />
                  )}
                  <Radio value={option.value} key={index}>
                    {option.label || `option ${index + 1}`}{' '}
                    {item.rules?.[index]?.jumpToSection && (
                      // <Typography.Text
                      //   type="secondary"
                      //   style={{ marginLeft: 16, cursor: 'pointer' }}
                      //   onClick={(e) => {
                      //     // scroll to the section
                      //     e.stopPropagation();
                      //     const sectionId = item.rules?.[index]?.jumpToSection;
                      //     if (!sectionId) return;
                      //     const section = document.querySelector(
                      //       `[data-element-container-id="${sectionId}"]`,
                      //     );
                      //     section.scrollIntoView({ behavior: 'smooth' });
                      //   }}
                      // >
                      //   <PullRequestOutlined style={{ marginRight: 4 }} />
                      //   {sectionMap[item.rules?.[index]?.jumpToSection]?.label ||
                      //     `Page ${sectionOrder.indexOf(item.rules?.[index]?.jumpToSection) + 1}`}
                      // </Typography.Text>
                      <Tag
                        icon={
                          <span className="anticon" role="img">
                            <ShuffleIcon />
                          </span>
                        }
                        style={{ marginLeft: 8, cursor: 'pointer' }}
                        onClick={(e) => {
                          // scroll to the section
                          e.stopPropagation();
                          const sectionId = item.rules?.[index]?.jumpToSection;
                          if (!sectionId) return;
                          const section = document.querySelector(
                            `[data-element-container-id="${sectionId}"]`,
                          );
                          section.scrollIntoView({ behavior: 'smooth' });
                        }}
                      >
                        {item.rules?.[index]?.jumpToSection === 'END'
                          ? 'Submit Form'
                          : sectionMap[item.rules?.[index]?.jumpToSection]?.label ||
                            `Page ${sectionOrder.indexOf(item.rules?.[index]?.jumpToSection) + 1}`}
                      </Tag>
                    )}
                  </Radio>
                </div>
              ))}
            {item?.options.length && item.allowOther && <Radio value="other">Other</Radio>}
          </Space>
        </Radio.Group>
      </Form.Item>

      <label className="sub-label" dangerouslySetInnerHTML={{ __html: item?.description }} />
      {hasDuplicateValues && (
        <div id="duplicate-error">
          <Alert type="error" message={t('errors.duplicateOptions')} showIcon />
        </div>
      )}
    </div>
  );
};

const CheckboxField = ({ item, errors, t }) => {
  // const { t } = useTranslation(['builder']);
  const hasUploads = (options) => {
    if (!options) return false;
    return options.some((option) => option.media && option.media.url);
  };

  const hasDuplicateValues = errors && errors.duplicateFields.find((id) => id === item?.questionId);
  return (
    <div className="form-group-container">
      <Form.Item
        label={item?.label}
        name={item?.id}
        required={item?.required}
        tooltip={item?.hint}
        style={{
          flexWrap: 'nowrap',
        }}
      >
        {item.media && item.media.url && (
          <div className="image-container banner">
            <img src={item.media?.url} alt={item.media?.name} />
          </div>
        )}
        <Checkbox.Group style={{ width: '100%' }} disabled>
          <Space
            wrap
            className={classNames({
              'grid-layout': hasUploads(item.options),
            })}
          >
            {item &&
              item.options &&
              item.options.map((option, index) => (
                <div key={index}>
                  {option.media && option.media.url && (
                    <div className="image-container options-image">
                      <img src={option.media.url} alt={option.media?.name} />
                    </div>
                  )}
                  {!option.media && hasUploads(item.options) && (
                    <div className="image-container-placeholder options-image" />
                  )}{' '}
                  <Checkbox value={option.value}>{option.label || `option ${index + 1}`}</Checkbox>
                </div>
              ))}
            {item?.options.length && item.allowOther && <Checkbox value="other">Other</Checkbox>}
          </Space>
        </Checkbox.Group>
      </Form.Item>

      <label className="sub-label" dangerouslySetInnerHTML={{ __html: item?.description }} />
      {hasDuplicateValues && (
        <div id="duplicate-error">
          <Alert type="error" message={t('errors.duplicateOptions')} showIcon />
        </div>
      )}
    </div>
  );
};

const DateInput = ({ item }) => {
  return (
    <div className="form-group-container">
      <Form.Item
        label={item?.label}
        name={item?.id}
        required={item?.required}
        tooltip={item?.hint}
        style={{ flexWrap: 'nowrap' }}
      >
        {item.media && item.media.url && (
          <div className="image-container banner">
            <img src={item.media?.url} alt="" />
          </div>
        )}
        <div
          style={{
            display: 'flex',
            gap: 16,
            flexWrap: 'wrap',
          }}
        >
          <DatePicker disabled />
          {item?.datePickerMode === 'datetime' && <TimePicker disabled />}
        </div>
      </Form.Item>
      <label className="sub-label" dangerouslySetInnerHTML={{ __html: item?.description }} />
    </div>
  );
};

const FileUploadField = ({ item, formLanguage, planHasAdvancedFields }) => {
  const props = {
    disabled: true,
  };
  const { t } = useTranslation();

  return (
    <div className="form-group-container">
      <Form.Item
        label={
          <>
            <span>{item?.label}</span>
            {!planHasAdvancedFields && (
              <AntdToolTip
                title={`${t('billing.formula')} ${t('billing.is-not-included-in-your-plan')}`}
                placement="right"
              >
                <ExclamationCircleFilled style={{ color: 'red', marginInlineStart: '0.5rem' }} />
              </AntdToolTip>
            )}
          </>
        }
        name={item?.id}
        required={item?.required}
        tooltip={item?.hint}
      >
        <Upload {...props}>
          <Button icon={<UploadOutlined />}>{formLocale.fileButton[formLanguage]}</Button>
        </Upload>
      </Form.Item>
      <label className="sub-label" dangerouslySetInnerHTML={{ __html: item?.description }} />
    </div>
  );
};

const ImageField = ({ item }) => {
  return (
    <div className="form-group-container">
      <div style={{ width: '96%' }}>
        <Typography.Title level={3} className="header-title">
          {item?.label}
        </Typography.Title>
        <div className={`image-container banner ${!item.media?.url && 'placeholder'}`}>
          <div className="iframe-overlay"></div>
          {item.media?.url ? (
            <img src={item.media?.url} alt={item.media?.url} />
          ) : (
            <img src={PlaceHolder} alt={item.media?.url} />
          )}
        </div>

        <label className="sub-label" dangerouslySetInnerHTML={{ __html: item?.description }} />
      </div>
    </div>
  );
};

const VideoField = ({ item }) => {
  return (
    <div className="form-group-container">
      <div style={{ width: '96%' }}>
        <Typography.Title level={3} className="header-title">
          {item?.label}
        </Typography.Title>
        <div className={`image-container banner ${!item.media?.url && 'placeholder'}`}>
          <div className="iframe-overlay" />
          {item.media?.url ? (
            <iframe
              src={embedUrlGenerator(item.media?.url)}
              frameBorder="0"
              allow="encrypted-media; fullscreen"
              style={{ width: '100%', height: '400px' }}
            />
          ) : (
            <img src={PlaceHolderVideo} alt={item.media?.url} />
          )}
        </div>

        <label className="sub-label" dangerouslySetInnerHTML={{ __html: item?.description }} />
      </div>
    </div>
  );
};

const AddressField = ({ item }) => {
  return (
    <div className="form-group-container">
      <Row>
        {item.fields?.map((field) => {
          const { id, enabled } = field;
          const span = field.id === 'addressLine1' || field.id === 'addressLine2' ? 24 : 12;
          if (!enabled) return null;
          return (
            <Col span={span} key={id}>
              <Form.Item
                label={field.label}
                name={field.id}
                required={field.required}
                tooltip={field.hint}
                style={{ flexWrap: 'nowrap' }}
              >
                <Input size="large" disabled />
              </Form.Item>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

const SectionDivider = ({ item, selected, planHasAdvancedFields }) => {
  const { t } = useTranslation();
  return (
    <div className="form-group-container" style={{ paddingInline: 0 }}>
      <div className={classNames('section-divider', { selected, error: !planHasAdvancedFields })}>
        <Divider plain style={{ margin: '0', color: '#888' }} orientation="left">
          {item?.label}
          {!planHasAdvancedFields && (
            <AntdToolTip
              title={`${t('billing.section')} ${t('billing.is-not-included-in-your-plan')}`}
              placement="right"
            >
              <ExclamationCircleFilled style={{ color: 'red', marginInlineStart: '0.5rem' }} />
            </AntdToolTip>
          )}
        </Divider>
      </div>
    </div>
  );
};

export {
  HeaderInput,
  TextInput,
  NumberInput,
  EmailInput,
  PhoneInput,
  RatingInput,
  SelectField,
  RadioField,
  CheckboxField,
  DateInput,
  ImageField,
  VideoField,
  FileUploadField,
  SectionDivider,
  FormulaField,
  PaymentField,
  AddressField,
};
